// extracted by mini-css-extract-plugin
export default {"container":"accordion_container__2XfkR","wrapper":"accordion_wrapper__38kR_","collapsed":"accordion_collapsed__fea8N"};